<template>
  <v-teleport to="#app">
    <div :id="id"
         ref="dialog"
         :data-bs-backdrop="!!persistent ? 'static' : null"
         aria-hidden="true"
         class="modal fade"
         tabindex="-1">
      <div class="modal-dialog"
           :class="[this.className, computedSize,
        {'modal-dialog-scrollable': scrollable},
        {'modal-dialog-centered': centered}]"
           :style="styles">
        <div class="modal-content">
          <div class="modal-header" :class="headerClases">
            <slot name="header"></slot>

            <v-btn v-if="!disableClose"
                   aria-label="Cerrar"
                   class="btn-close btn-transparent"
                   data-bs-dismiss="modal">
              <v-icon icon="plus" size="xl"></v-icon>
            </v-btn>
          </div>

          <div class="modal-body" :class="bodyClases">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer" :class="footerClases">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </v-teleport>
</template>

<script>
export default {
  name: 'VDialog',
  emits: ['closed'],
  props: {
    id: {
      type: String,
      required: false,
      default: 'modal',
    },
    size: {
      type: String,
      required: false,
      default: 'lg',
    },
    className: {
      type: String,
      required: false,
      default: null,
    },
    disableClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: Boolean,
    persistent: Boolean,
    scrollable: Boolean,
    centered: {
      type: Boolean,
      default: true,
    },
    fullscreen: Boolean,
    maxWidth: [String, Number],
    width: [String, Number],
    headerClases: String,
    bodyClases: String,
    footerClases: String,
  },
  computed: {
    computedSize() {
      return !!this.size ? `modal-${ this.size }` : '';
    },
    styles() {
      return {
        'max-width': !!this.maxWidth ? this.maxWidth : '',
        width: !!this.width ? this.width : '',
      };
    },
  },
  mounted() {
    this.setup();
  },
  data() {
    return {
      doEmitOnClose: true,
    };
  },
  methods: {
    setup() {
      const $modal = this.$refs.dialog;

      const config = {};
      if (this.persistent) {
        config.backdrop = 'static';
      }

      this.modal = new Modal($modal, config);

      $modal.addEventListener('hidden.bs.modal', () => {
        if (!!this.doEmitOnClose) {
          this.$emit('closed');
        }
      });
    },
    open() {
      this.modal.show();
    },
    close() {
      this.modal.hide();
    },
    dispose() {
      this.modal.dispose();
    },
    toggle() {
      this.modal.toggle();
    },
  },
  beforeUnmount() {
    this.modal.close();
  },
};
</script>

<style lang="scss" scoped>
@import "VDialog";
</style>
